const PrivacyPolicy = () => {
  return (
    <section className="py-12">
      <div className="container">
        {/* HEADING */}
        <div className="pb-3 border-b border-[#E5E5E5]">
          <h1 className="text-4xl font-source font-bold text-black">
            PRIVACY POLICY
          </h1>
        </div>

        {/* CONTENT */}
        <div className="mt-5 flex flex-col space-y-5 text-lg font-source font-normal text-greyText">
          <p>
            Alumni Connection Hub (“the Company”, “we”, “us”, or “our”) is
            committed to protecting your privacy. This Privacy Policy explains
            what information we collect when you use our websites, applications,
            and related online services (“Services”), how we use it, and the
            choices you have.
          </p>

          <p>
            By accessing or using our Services, you agree to this Privacy
            Policy. If you do not agree, please discontinue use of the Services.
          </p>

          {/* 1. Information We Collect */}
          <div>
            <h5 className="text-xl font-source font-semibold text-black">
              1. Information We Collect
            </h5>
          </div>

          <p>
            We collect information you provide directly, information collected
            automatically through your device and browsing activity, and
            information obtained from third parties such as social login
            providers.
          </p>

          <ul className="list-disc pl-6 space-y-2">
            <li>
              <strong>Information You Provide:</strong> Name, email, mobile
              number, profile photo, account credentials, educational and
              professional details, posts, photos, comments, messages, and
              transaction data.
            </li>
            <li>
              <strong>Automatically Collected Information:</strong> IP address,
              device details, browser type, pages viewed, usage patterns,
              interactions, cookies, location data (when enabled), and mobile
              device identifiers.
            </li>
            <li>
              <strong>Information from Third Parties:</strong> Data received
              from social logins (Google/Facebook), public sources, and trusted
              partners.
            </li>
          </ul>

          {/* 2. How We Use the Information */}
          <div>
            <h5 className="text-xl font-source font-semibold text-black">
              2. How We Use Your Information
            </h5>
          </div>

          <p>We use the information we collect to:</p>

          <ul className="list-disc pl-6 space-y-2">
            <li>Operate, maintain, and improve our Services.</li>
            <li>Personalize content and user experience.</li>
            <li>Process transactions and manage user accounts.</li>
            <li>
              Communicate important updates, offers, and service notifications.
            </li>
            <li>Provide customer support and respond to inquiries.</li>
            <li>Conduct analytics, reporting, and research.</li>
            <li>Enforce our Terms of Use and comply with legal obligations.</li>
          </ul>

          {/* 3. How We Share Information */}
          <div>
            <h5 className="text-xl font-source font-semibold text-black">
              3. How We Share Your Information
            </h5>
          </div>

          <p>
            We may share your information with affiliated institutes, service
            providers, authorized vendors, payment processors, legal authorities
            (when required), and third parties when you give explicit consent.
          </p>

          <p>
            We do not sell your personal information to advertising agencies or
            third-party marketers.
          </p>

          {/* 4. Your Choices */}
          <div>
            <h5 className="text-xl font-source font-semibold text-black">
              4. Your Choices
            </h5>
          </div>

          <ul className="list-disc pl-6 space-y-2">
            <li>You can update or delete your profile information anytime.</li>
            <li>You can disable cookies through browser settings.</li>
            <li>You may unsubscribe from promotional messages.</li>
          </ul>

          <p>
            To permanently delete your account, contact us at
            <a href="mailto:admin@alumniconnectionhub.com">
              {" "}
              admin@alumniconnectionhub.com
            </a>
            .
          </p>

          {/* 5. Security */}
          <div>
            <h5 className="text-xl font-source font-semibold text-black">
              5. Data Security
            </h5>
          </div>

          <p>
            We implement industry-standard security measures, including
            encryption and secure third-party processors. However, no system is
            completely secure. Users are responsible for maintaining the
            confidentiality of their account credentials.
          </p>

          {/* 6. Children */}
          <div>
            <h5 className="text-xl font-source font-semibold text-black">
              6. Children Under 13
            </h5>
          </div>

          <p>
            Our Services are not intended for children under 13. We do not
            knowingly collect data from children under 13. If you believe such
            data exists, contact us for removal.
          </p>

          {/* 7. Retention */}
          <div>
            <h5 className="text-xl font-source font-semibold text-black">
              7. Data Retention
            </h5>
          </div>

          <p>
            We retain data only as long as necessary for business, legal, or
            security purposes. After deleting your account, some information may
            remain in backups or anonymized records.
          </p>

          {/* 8. International Transfers */}
          <div>
            <h5 className="text-xl font-source font-semibold text-black">
              8. International Data Transfers
            </h5>
          </div>

          <p>
            Your information may be processed outside your country of residence.
            By using our Services, you consent to such transfers.
          </p>

          {/* 9. Third Party Links */}
          <div>
            <h5 className="text-xl font-source font-semibold text-black">
              9. Third-Party Links
            </h5>
          </div>

          <p>
            Our Services may include links to third-party websites. We are not
            responsible for their privacy practices. Please review those
            policies separately.
          </p>

          {/* 10. Changes */}
          <div>
            <h5 className="text-xl font-source font-semibold text-black">
              10. Changes to This Policy
            </h5>
          </div>

          <p>
            We may update this Privacy Policy from time to time. Continued use
            of the Services after updates constitutes acceptance of the revised
            policy.
          </p>

          {/* 11. Contact */}
          <div>
            <h5 className="text-xl font-source font-semibold text-black">
              11. Contact Us
            </h5>
          </div>

          <p>
            For any queries regarding this Privacy Policy or your personal data,
            please contact us at:
            <br />
            <a href="mailto:admin@alumniconnectionhub.com">
              admin@alumniconnectionhub.com
            </a>
          </p>
        </div>
      </div>
    </section>
  );
};

export default PrivacyPolicy;
